module.exports = __webpack_public_path__ + "img/南皮五金.8958261b.jpg";